<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div class="flex item-center">
        <el-button type="primary" class="mr10" size="small" @click="addBrand"
          >添加品牌</el-button
        >

        <div @click="outputExcel" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出模板
        </div>
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          导入品牌
          <input
            type="file"
            @change="importf"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.brandName"
          placeholder="搜索品牌"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>

    <div class="table">
      <el-table
        :data="hemiaoBrandList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <!-- <el-table-column type="selection"></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="品牌名称"
          prop="brandName"
        ></el-table-column>
        <el-table-column
          prop="logoPic"
          header-align="center"
          align="center"
          label="品牌LOGO"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-image
                style="width: 60px; height: 60px"
                :src="scope.row.logoPic"
                :preview-src-list="[scope.row.logoPic]"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandInitials"
          label="品牌首字母"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandInitials"
          label="系列数"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="150"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="seriesManagement(scope.row)"
                >系列管理</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="edit(scope.row)"
                >编辑</el-button
              >
              <!-- <el-tooltip class="item" content="编辑" placement="top">
                <div class="pointer" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </div>
              </el-tooltip> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="hemiaoBrandList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="品牌名称" prop="brandName">
          <el-input
            clearable
            v-model.trim="ruleForm.brandName"
            maxlength="20"
            size="small"
            placeholder="请输入品牌名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="品牌编号" prop="brandCode">
          <el-input
            clearable
            v-model.trim="ruleForm.brandCode"
            maxlength="20"
            size="small"
            placeholder="请输入品牌编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="品牌首字母" prop="brandInitials">
          <el-input
            clearable
            v-model.trim="ruleForm.brandInitials"
            maxlength="20"
            size="small"
            placeholder="请输入品牌首字母"
          ></el-input>
        </el-form-item>
        <el-form-item label="品牌LOGO" prop="logoPic">
          <div class="flex upload-upload-btn">
            <div
              class="btn flex flex-column flex-center open-file"
              @click="show = true"
              v-if="!ruleForm.logoPic"
            >
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>添加图片</span>
            </div>
            <div v-if="ruleForm.logoPic" class="mr10 flex item-end priview">
              <img class="logo" :src="ruleForm.logoPic" alt="logo" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
            <div class="flex flex-column flex-end">
              <!-- <div class="tips">只能上传jpg/png文件，且不能超过1MB</div> -->
              <div class="tips">建议图片尺寸为400x400px(最多上传一张）</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm('ruleForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
      <my-upload
        field="file"
        @crop-upload-success="cropUploadSuccess"
        v-model="show"
        noCircle
        noSquare
        :noRotate="false"
        :width="200"
        :height="200"
        :headers="{ 'X-Access-Token': $token }"
        :params="{ fileDir: 'goodsCenter' }"
        :url="$uploadUrl"
        img-format="png"
      ></my-upload>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errInputResult.length }}</span
            >条数据导入失败
            <div class="error">
              品牌名称重复,编号重复,未填写必填项
            </div>
          </div>

          <!-- <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div> -->
        </div>
        <el-table
          :data="errInputResult"
          border
          stripe
          class="small-table"
          max-height="500"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandCode"
            label="品牌编号"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandInitials"
            label="品牌首字母"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="系列管理"
      :visible.sync="dialogVisibleSeries"
      width="800px"
    >
      <div class="flex ">
        <div class="title mr10">
          添加系列
        </div>
        <div style="width:600px">
          <div class="flex">
            <el-input
              clearable
              v-model.trim="seriesName"
              maxlength="20"
              size="small"
              style="width:380px"
              placeholder="请输入系列名称"
            ></el-input>
            <div class="add-wrappers" @click="addSeries">
              <span class="hmicon icon-hao pointer"></span>
            </div>
          </div>
          <div class="mt10">
            <el-table
              :data="seriesList"
              border
              stripe
              class="small-table"
              max-height="500"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
              ></el-table-column>
              <el-table-column
                header-align="left"
                align="left"
                prop="seriesName"
                label="系列名称"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="150"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <div class="minus-wrapper" style="margin-left:0">
                      <span
                        class="hmicon icon-jianhao pointer"
                        @click="deleteSeries(scope.row, scope.$index)"
                      ></span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="dialogVisibleSeries = false"
          >确 定</el-button
        >
        <el-button size="small" @click="dialogVisibleSeries = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { arrayUnique2 } from "@/utils/utils";
import myUpload from "vue-image-crop-upload";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { myUpload },
  data() {
    const patternLocation = function(rule, val, callback) {
      let haveEmptyCondition = false;

      const reg = /^[A-Z]+$/;
      if (!reg.test(val)) {
        haveEmptyCondition = true;
      }
      if (haveEmptyCondition) {
        return callback(new Error("请输入一个大写英文字母"));
      }
      callback();
    }.bind(this);
    return {
      seriesList: [],
      seriesName: "",
      dialogVisibleSeries: false,
      errValidGoods: false,
      errInputResult: [],
      searchCondition: {},
      show: false,
      checkedRow: [],
      ruleForm: {
        brandName: "",
        brandCode: "",
        brandInitials: "",
        logoPic: ""
      },
      rules: {
        logoPic: {
          required: false,
          message: "请选择品牌LOGO！",
          trigger: "blur"
        },
        brandName: [
          {
            required: true,
            message: "请输入品牌名称",
            trigger: "blur"
          },
          {
            required: true,
            min: 2,
            max: 20,
            message: "名称应大于2小于20个字",
            trigger: "blur"
          }
        ],
        brandCode: [
          {
            required: true,
            message: "请输入品牌编码",
            trigger: "blur"
          }
        ],
        brandInitials: [
          {
            required: true,
            message: "请输入品牌首字母",
            trigger: "blur"
          },
          { max: 1, message: "请输入一个大写英文字母", trigger: "blur" },
          {
            required: true,
            validator: patternLocation,
            trigger: "blur"
          }
        ]
      },
      num: 0,
      currentPage: 1,
      pageSize: 10,
      title: "",
      dialogVisible: false
    };
  },
  computed: mapGetters(["hemiaoBrandList"]),
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    reset() {
      this.series = "";
      this.seriesList = [];
    },
    async save() {
      if (this.seriesList.length) {
        await this.$store.dispatch("");
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.reset();
        this.dialogVisibleSeries = false;
      } else {
        this.$message({
          message: "请添加系列",
          type: "warning"
        });
      }
    },
    async addSeries() {
      if (this.seriesName) {
        // if( this.seriesList.findIndex(v=>v.seriesName===this.seriesName)>-1){

        // }
        await this.$store.dispatch("addPageSeriesList", {
          hemiaoBrandId: this.row.hemiaoBrandId,
          seriesName: this.seriesName
        });
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        await this.queryPageSeriesList();
        // this.seriesList.push({
        //   seriesName: this.seriesName
        // });
        // this.seriesList = arrayUnique2(this.seriesList, "seriesName");
      } else {
        this.$message({
          message: "请输入系列名称",
          type: "warning"
        });
      }
    },

    async deleteSeries(row, i) {
      await this.$store.dispatch("deletePageSeriesList", {
        seriesId: row.seriesId
      });

      this.$message({
        message: "操作成功！",
        type: "success"
      });
      await this.queryPageSeriesList();

      // this.seriesList.splice(i, 1);
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];
        let importfList = [];
        result.forEach(v => {
          if (v[0] && v[1] && v[2]) {
            formatResult.push({
              brandName: v[0],
              brandCode: v[1],
              brandInitials: v[2]
            });
          } else {
            importfList.push({
              brandName: v[0],
              brandCode: v[1],
              brandInitials: v[2]
            });
          }
        });

        formatResult.length &&
          that.$store
            .dispatch("batchSaveHemiaoBrandinfo", formatResult)
            .then(res => {
              const { code, result } = res;
              console.log("result: ", result);
              if (code === "0") {
                if (result.length) {
                  that.errValidGoods = true;
                  result.push(...importfList);
                  that.errInputResult = result;
                  that.$message({
                    message: "部分品牌导入失败！",
                    type: "warning"
                  });
                }
                that.queryList();
                that.$forceUpdate();
              }
            });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");

        const tHeader = [
          "品牌名称(必填)",
          "品牌编号(必填)",
          "品牌首字母(必填)"
        ];

        const data = [];
        exportJsonToExcel(tHeader, data, "导入品牌模板");
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleRemove() {
      this.ruleForm.logoPic = "";
    },
    cropUploadSuccess(jsonData) {
      this.ruleForm.logoPic = jsonData.result;
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
      this.num = selection.length;
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryHemiaoBrandList", params);
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    seriesManagement(row) {
      this.row = row;
      this.queryPageSeriesList();
      this.reset();
      this.dialogVisibleSeries = true;
    },
    async queryPageSeriesList() {
      const { result } = await this.$store.dispatch("queryPageSeriesList", {
        hemiaoBrandId: this.row.hemiaoBrandId
      });
      this.seriesList = result.records;
    },
    edit(row) {
      this.title = "编辑品牌";
      this.dialogVisible = true;
      let params = {
        hemiaoBrandId: row.hemiaoBrandId
      };
      this.$store.dispatch("detailsHemiaoBrandList", params).then(res => {
        if (res.code === "0") {
          for (let key in res.result) {
            this.ruleForm[key] = res.result[key];
          }
        }
      });
    },
    addBrand() {
      this.title = "添加品牌";
      this.dialogVisible = true;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);
    },
    confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;

          this.$store
            .dispatch(
              this.title === "添加品牌"
                ? "saveHemiaoBrandList"
                : "editHemiaoBrandList",
              params
            )
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                setTimeout(() => {
                  this.resetRuleForm();
                }, 0);
                this.dialogVisible = false;
                this.queryList();
              }
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priview {
  position: relative;
  .logo {
    width: 100px;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.title {
  font-weight: bold;
  width: 60px;
  height: 32px;
  line-height: 32px;
}
.add-wrappers {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  margin-left: 10px;
  .hmicon {
    font-size: 14px;
  }
}
</style>
